import { Theme } from "@mui/material/styles"

interface Styles {
  [key: string]: any
}

export const styles = (theme: Theme): Styles => ({
  container: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    padding: theme.spacing.spacing6,
  },
  headerRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: theme.spacing.spacing12_5,
  },
  logo: {
    height: "32px",
    width: "auto",
  },
  bodyContainer: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    justifyContent: "center",
    alignItems: "flex-start",
  },
  bodyContentLTR: {
    paddingLeft: theme.spacing.spacing6,
  },
  bodyContentRTL: {
    paddingRight: theme.spacing.spacing6,
  },
  title: {
    fontSize: theme.typography.size.lg,
    fontWeight: theme.typography.fontWeightBold,
    lineHeight: "28px",
    marginBottom: theme.spacing.spacing7,
  },
  description: {
    fontSize: theme.typography.size.sm,
    fontWeight: theme.typography.fontWeightRegular,
    lineHeight: "22px",
    whiteSpace: "pre-line",
    marginBottom: theme.spacing.spacing12_5,
  },
})
